import axios from './api';
import { getUrl } from './utils';

const endPoint = getUrl('ehe') + '/digitalconcrete';

export const downloadPDF = async (projectId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(
        `${endPoint}/export-traceability`,
        new URLSearchParams({ project_id: projectId.toString() }),
        {
          responseType: 'blob',
        },
      );

      const contentDisposition = response.headers['content-disposition'];
      const fileNameMatch = contentDisposition?.match(/filename="?(.+?)"?$/);
      const fileName = fileNameMatch ? fileNameMatch[1] : 'export.pdf';

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      resolve();
    } catch (error) {
      reject(error);
    }
  });
};

export const getProjectStatus = async (projectId) => {
  const url = `${endPoint}/task-status?project_id=${projectId}`;
  const headers = {
    'Content-Type': 'application/json',
  };
  const response = await axios.get(url, { headers });
  return response.data;
};

export function postScript({
  projectId,
  lotification,
  deliveryNoteId,
  finalBatchId,
  initialBatchId,
}) {
  const formData = new FormData();
  formData.append('project_id', projectId);
  if (deliveryNoteId) {
    formData.append('delivery_note_id', deliveryNoteId);
  }
  if (initialBatchId) {
    formData.append('initial_batch_id', initialBatchId);
  }
  if (finalBatchId) {
    formData.append('final_batch_id', finalBatchId);
  }
  if (lotification) {
    formData.append('lotification', lotification);
  }
  const url = `${endPoint}/gui-task`;
  return axios.post(url, formData);
}

export function getUpdateTasks(id) {
  const url = `${endPoint}/task-status/${id}`;
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.get(url, { headers });
}
